import React, { createContext, useContext, useState } from 'react'

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
	const [DataIdList, setDataIdList] = useState("");

	//? hambMenu
	const [hambShow, setHambShow] = useState(false);

	// ? data for logo loding
	const [isLoadingFinishing, setIsLoadingFinishing] = useState(false);

	//? data for showMore
	const [showMore, setShowMore] = useState(false);

	//? for show big image url
	const [showBig, setShowBig] = useState(false);
	const [imgUrl, setImgUrl] = useState("");

	//? get data selected project list to <<EmployerSelectList >> component
	const [selectedDataId , setSelectedDataId] = useState(sessionStorage.getItem('selectedProj')??'');

	const setLoadingFinish = () => {
		setIsLoadingFinishing(true);
	}

	return (
		<DataContext.Provider value={{
			showBig, setShowBig, imgUrl, setImgUrl, showMore, setShowMore, DataIdList, setDataIdList, isLoadingFinishing, setLoadingFinish, hambShow, setHambShow ,selectedDataId , setSelectedDataId
		}}>
			{children}
		</DataContext.Provider>
	);
};

export const useLoading = () => useContext(DataContext);
